import React, { createContext, useContext, useState } from 'react';

const translations = {
  en: {
    appName: 'NRK Mart', tagline: 'Fresh from farm to your door',
    home: 'Home', cart: 'Cart', orders: 'Orders', offers: 'Offers',
    support: 'Support', profile: 'Profile', wallet: 'Wallet',
    addresses: 'Addresses', settings: 'Settings', signIn: 'Sign In', signOut: 'Sign Out',
    cancel: 'Cancel', confirm: 'Confirm', save: 'Save', close: 'Close',
    back: 'Back', next: 'Next', loading: 'Loading...',
    addToCart: 'Add', perKg: '/kg', totalItems: 'items', cartEmpty: 'Your cart is empty',
    cartTitle: 'Your Cart', removeItem: 'Remove', inStock: 'In Stock', outOfStock: 'Out of Stock',
    quantity: 'Quantity', kg: 'kg', total: 'Total', subtotal: 'Subtotal',
    customQty: 'Custom', selectQty: 'Select quantity', searchPlaceholder: 'Search products...', allCategory: 'All',
    submitOrder: 'Place Order', reviewOrder: 'Review Your Order', confirmOrder: 'Proceed to Checkout',
    orderSuccess: 'Order Placed Successfully!', orderSuccessMsg: "Check WhatsApp for confirmation. We'll reach out soon!",
    orderNumber: 'Order #', newOrder: 'Place New Order',
    name: 'Your Name', phone: 'Phone Number', email: 'Email (optional)', notes: 'Delivery Notes (optional)',
    paymentMethod: 'Payment Method', cod: 'Cash on Delivery', upi: 'UPI / QR', useWallet: 'Pay with Wallet',
    deliveryNormal: 'Standard delivery (free)', deliveryImmediate: 'Priority delivery',
    groupDeliveryNote: 'Delivered in the next group batch (no fixed ETA)',
    enterName: 'Your Name', enterPhone: 'WhatsApp Number',
    enterNamePlaceholder: 'Enter your name', enterPhonePlaceholder: '+91 99999 99999',
    enterOtp: 'Enter 6-digit OTP', sendOtp: 'Send OTP', verifyOtp: 'Verify', resendOtp: 'Resend OTP',
    startShopping: 'Start Shopping', nameRequired: 'Please enter your name',
    phoneRequired: 'Please enter your phone number', orContinueGuest: 'or continue without details',
    consentText: 'I agree to share my name and phone for order delivery (DPDP).',
    welcomeTitle: 'Welcome to NRK Mart!', welcomeSub: 'Fresh vegetables and groceries delivered to your door',
    trackOrder: 'Track Order', myOrders: 'My Orders', cancelOrder: 'Cancel Order', requestReturn: 'Request Return',
    langToggle: 'Telugu', greeting: (name) => 'Hello, ' + name + '!',
  },
  te: {
    appName: 'NRK Mart', tagline: 'Fresh from farm to your door',
    home: 'Home', cart: 'Cart', orders: 'Orders', offers: 'Offers',
    support: 'Support', profile: 'Profile', wallet: 'Wallet',
    addresses: 'Addresses', settings: 'Settings', signIn: 'Sign In', signOut: 'Sign Out',
    cancel: 'Cancel', confirm: 'Confirm', save: 'Save', close: 'Close',
    back: 'Back', next: 'Next', loading: 'Loading...',
    addToCart: 'Add', perKg: '/kg', totalItems: 'items', cartEmpty: 'Your cart is empty',
    cartTitle: 'Your Cart', removeItem: 'Remove', inStock: 'In Stock', outOfStock: 'Out of Stock',
    quantity: 'Quantity', kg: 'kg', total: 'Total', subtotal: 'Subtotal',
    customQty: 'Custom', selectQty: 'Select quantity', searchPlaceholder: 'Search products...', allCategory: 'All',
    submitOrder: 'Place Order', reviewOrder: 'Review Your Order', confirmOrder: 'Proceed to Checkout',
    orderSuccess: 'Order Placed Successfully!', orderSuccessMsg: 'Check WhatsApp for confirmation.',
    orderNumber: 'Order #', newOrder: 'Place New Order',
    name: 'Your Name', phone: 'Phone Number', email: 'Email (optional)', notes: 'Delivery Notes (optional)',
    paymentMethod: 'Payment Method', cod: 'Cash on Delivery', upi: 'UPI / QR', useWallet: 'Pay with Wallet',
    deliveryNormal: 'సాధారణ డెలివరీ (ఉచితం)', deliveryImmediate: 'ప్రాధాన్య డెలివరీ',
    groupDeliveryNote: 'తదుపరి గ్రూప్ బ్యాచ్‌లో డెలివరీ (నిర్ణీత సమయం లేదు)',
    enterName: 'Your Name', enterPhone: 'WhatsApp Number',
    enterNamePlaceholder: 'Enter your name', enterPhonePlaceholder: '+91 99999 99999',
    enterOtp: 'Enter 6-digit OTP', sendOtp: 'Send OTP', verifyOtp: 'Verify', resendOtp: 'Resend OTP',
    startShopping: 'Start Shopping', nameRequired: 'Please enter your name',
    phoneRequired: 'Please enter your phone number', orContinueGuest: 'or continue without details',
    consentText: 'I agree to share my name and phone for order delivery (DPDP).',
    welcomeTitle: 'Welcome to NRK Mart!', welcomeSub: 'Fresh vegetables delivered to your door',
    trackOrder: 'Track Order', myOrders: 'My Orders', cancelOrder: 'Cancel Order', requestReturn: 'Request Return',
    langToggle: 'English', greeting: (name) => 'Hello, ' + name + '!',
  },
};

const LANG_KEY = 'nrk_lang';
const getStoredLang = () => { try { const v = localStorage.getItem(LANG_KEY); return (v === 'en' || v === 'te') ? v : 'en'; } catch { return 'en'; } };
const setStoredLang = (l) => { try { localStorage.setItem(LANG_KEY, l); } catch {} };

const LangContext = createContext(null);

export function LangProvider({ children, initialLang }) {
  const [lang, setLang] = useState(() => initialLang || getStoredLang());
  const setLanguage = (l) => { setLang(l); setStoredLang(l); };
  const toggle = () => setLanguage(lang === 'en' ? 'te' : 'en');
  const value = { lang, t: translations[lang], toggle, toggleLang: toggle, setLanguage };
  return React.createElement(LangContext.Provider, { value }, children);
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error('useLang must be inside LangProvider');
  return ctx;
}

export { translations };
